import React, { createContext, useContext, useState, useCallback } from 'react';

const RecruiterModeContext = createContext();

export const useRecruiterMode = () => {
    const context = useContext(RecruiterModeContext);
    if (!context) {
        throw new Error('useRecruiterMode must be used within a RecruiterModeProvider');
    }
    return context;
};

export const RecruiterModeProvider = ({ children }) => {
    const [isRecruiterMode, setIsRecruiterMode] = useState(false);

    const toggleRecruiterMode = useCallback(() => {
        setIsRecruiterMode(prev => !prev);
    }, []);

    const value = {
        isRecruiterMode,
        toggleRecruiterMode
    };

    return (
        <RecruiterModeContext.Provider value={value}>
            {children}
        </RecruiterModeContext.Provider>
    );
};
